var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CUSTOMER_MULTIPASS_URL_QUERY = exports.GET_CUSTOMER_ORDERS = exports.GET_CUSTOMER = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const customerFragment_1 = require("../fragments/customerFragment");
const orderFragment_1 = require("../fragments/orderFragment");
const mailingAddressFragment_1 = require("../fragments/mailingAddressFragment");
exports.GET_CUSTOMER = (0, graphql_tag_1.default) `
  query GET_CUSTOMER($customerAccessToken: String!) {
    customer(customerAccessToken: $customerAccessToken) {
      ...CustomerFragment
      addresses(first: 10) {
        edges {
          node {
            ...MailingAddressFragment
          }
        }
      }
    }
  }
  ${customerFragment_1.CUSTOMER_FRAGMENT}
  ${mailingAddressFragment_1.MAILING_ADDRESS_FRAGMENT}
`;
exports.GET_CUSTOMER_ORDERS = (0, graphql_tag_1.default) `
  query GET_CUSTOMER_ORDERS($customerAccessToken: String!, $first: Int!, $reverse: Boolean = false) {
    customer(customerAccessToken: $customerAccessToken) {
      orders(first: $first, reverse: $reverse) {
        edges {
          cursor
          node {
            ...OrderFragment
          }
        }
        pageInfo {
          hasNextPage
        }
      }
    }
  }
  ${orderFragment_1.ORDER_FRAGMENT}
`;
exports.CUSTOMER_MULTIPASS_URL_QUERY = (0, graphql_tag_1.default) `
  query CUSTOMER_MULTIPASS_URL_QUERY($shopName: String!, $idToken: String!, $returnUrl: String!) {
    multipassUrl(shopName: $shopName, idToken: $idToken, returnUrl: $returnUrl) {
      url
    }
  }
`;
//# sourceMappingURL=customer.js.map